import { HotelImage } from 'shared/api/tours/search'
import EmptyImage from 'shared/images/empty-image.webp'
import { Carousel } from 'shared/ui/carousel'

interface Props {
  images: HotelImage[]
  onClick?: () => void
}

export const RoomCarousel = ({ images, onClick }: Props) => {
  if (!images.length) return null

  return (
    <div onClick={onClick}>
      <Carousel
        dotsVariant="custom"
        images={images.map((i, index) => ({
          id: String(index),
          image: i.src,
          image_fullpath: i.src,
        }))}
        errorImage={EmptyImage}
        showCounter
        size="large"
      />
    </div>
  )
}
